module.exports = __webpack_public_path__ + "static/media/camida.da491f7e.png";